export function updateFAQ(state: any, payload: any) {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload,
    },
  };
}
